<template>
 <div class="header" :class="{open : showMobileMenu }">
	<div class="top">
		<div class="box2 cf">
			<a :href="protocolUrl+'//'+hostnameUrl" class="logo fl dpb">
				<img :src="logoUrl">
			</a>


			<div class="mobileMask" @click="shmmFun"></div>
			<div class="mobileMenu" @click="shmmFun"></div>


			<div class="loginAndSite fr cf f-14">
				<!-- <a class="loginPerson" href="javascript:;">个人中心</a> -->
				<div class="searchBtn fl"></div>
				<div class="selectBox fl">
		        	<div class="inputCase" @click="siteSelectFun">总站</div>
					<div class="selectUI" :style="{display:siteSelectShow ? 'block' : '' }">
						<div class="selectCont">
							<h3 class="f-16">分平台</h3>
							<ul class="cf f-14">
								<li :oliName="item.title" :class="{'on':index == 0}" v-for="(item,index) in subPlatform"><a :href="item.linkUrl">{{item.title}}</a></li>
							</ul>
						</div>
					</div>
		        </div>
			</div>
		</div>
	</div>

	<div class="bot">
		<div class="box2 mainMenu">
			<div class="item" v-for="(item,index) in menusList">
				<a class="mNav" :href="item.linkUrl">{{item.title}}</a>
			</div> 
		</div>
	</div> 
</div>
	<!-- <div v-html="headHtml"></div> -->
</template>
<script>
import { getHeader ,getBaseInfo} from "@/api/person/person";
export default {
	name: 'heads',
	data(){
		return{
			headHtml:'',
			siteSelectShow:false,
			showMobileMenu:false,
			logoUrl:'',
			menusList:[],
			subPlatform:[],
			hostnameUrl:window.location.hostname,
			protocolUrl:window.location.protocol
		}
	},
	mounted(){
		let that=this;
		//that.getHeaderFun()
		that.getHeadInfoFun()

	    //获取微信扫码结果
	    window.addEventListener('message', (e) => {
	      //console.log(e)
	      let datas=''
	      if (typeof e.data === 'string') {
	        datas=JSON.parse(e.data)
	      }else{
	        datas=e.data
	      }
	      if (datas.code=='200') {
	        that.$message.success(datas.msg);

	        window.sessionStorage.setItem('token',datas.data);
	        window.localStorage.setItem('token',datas.data);

	        setTimeout(function(){
	           window.location.reload()
	        },1000)
	      }else if (datas.code=='201') {
	        that.$message.success(datas.msg);
	      }else{
	        if (datas.msg) {
	          that.$message.error(datas.msg);
	        }
	      }
	    });
	},
	activated(){
		
	},
	computed:{
		
	},
	methods: {
		getHeaderFun(){
	      let that=this
	      getHeader({}).then(res => {
	        //console.log(res)
	        that.headHtml=res
	      });
	    },

	    getHeadInfoFun(){
	      let that=this
	      getBaseInfo({}).then(res => {
	        //console.log(res)
	        if(res.success) {
	        	let siteAdList=res.result.siteAdList
	        	that.logoUrl=res.result.logo 

	        	let menusList=res.result.menus
	        	let baseUrl=that.protocolUrl+'//'+that.hostnameUrl
	        	menusList.forEach((item,index)=>{
	        		if (item.linkUrl.includes("https://www.zgjzcy.org.cn")) {
	        			item.linkUrl=item.linkUrl.replace("https://www.zgjzcy.org.cn", baseUrl)
	        		}
	        	})

	        	that.menusList=menusList
	        	that.subPlatform=res.result.subPlatform
	        	siteAdList.forEach((item,index)=>{
	        		if (that.hostnameUrl==item.domain) {
	        			that.logoUrl=item.image
	        		}
	        	})
	        }
	      });
	    },

	    siteSelectFun(){
	    	let that=this
	    	that.siteSelectShow=!that.siteSelectShow
	    },

	    shmmFun(){
	    	let that=this
	    	that.showMobileMenu=!that.showMobileMenu
	    }
   	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/heads/index.vue